import { render, staticRenderFns } from "./UIUX.vue?vue&type=template&id=5b099fcc&scoped=true"
import script from "./UIUX.vue?vue&type=script&lang=js"
export * from "./UIUX.vue?vue&type=script&lang=js"
import style0 from "./UIUX.vue?vue&type=style&index=0&id=5b099fcc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b099fcc",
  null
  
)

export default component.exports